/**
 * @param callback Function to call after delay
 * @param delay delay in milliseconds
 * @param onInterval should the callback be called on interval or once after delay (default)
 * @returns Function to clear the timeout/interval and the timeout, interval IDs
 */
const delayCallback = (callback: () => void, delay = 0, onInterval = false) => {
  let timeoutId: NodeJS.Timeout | undefined;
  let intervalId: NodeJS.Timeout | undefined;

  if (onInterval) {
    intervalId = setInterval(callback, delay);
  } else {
    timeoutId = setTimeout(callback, delay);
  }

  const clear = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = undefined;
    }
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = undefined;
    }
  };

  return {
    clear,
    intervalId,
    timeoutId,
  };
};

export default delayCallback;
